import './configs/sentry.config'

import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'

import { configTranslation } from '@shared/application/translation.service'
import posthog from 'posthog-js'
import { PostHogProvider } from 'posthog-js/react'
import App from './app'
import { configureYup } from './configs/yup.config'
import { env } from './env'

configTranslation()

const posthogApiHost = env.isPosthogProxyEnabled ? '/ph' : 'https://app.posthog.com'

posthog.init('phc_giw1JRrVYltLMIdO0vu5z3FQAiAWJlrKYFXcZR81VTH', {
  api_host: posthogApiHost,
  opt_in_site_apps: true,
})

configureYup()

const container = document.getElementById('root')
const root = createRoot(container!, {
  onRecoverableError: (error, errorInfo) => {
    if (env.isDev) {
      if (error instanceof Error) {
        console.error('Recoverable error', error, error.cause, errorInfo.componentStack)
      } else {
        console.error('Recoverable error', error, errorInfo.componentStack)
      }
    }
  },
  // onUncaughtError: // In Canary release, add logging here once feature is out
})
root.render(
  <StrictMode>
    <PostHogProvider client={posthog}>
      <App />
    </PostHogProvider>
  </StrictMode>
)
